import {DisplaySession} from 'helpers/enums/display-session';

/**
 * Returns a unique list of objects to use as filter options for sessions
 * This list is based on what the user has in their sessions
 * (If they have match/dsd then only match and dsd will be options)
 */
const SessionFilterHelper = {
  'buildTypeFilters': function(data, action) {
    const currentTypes = [];

    const filters = data.map(obj => {
      if (currentTypes.includes(obj.session_type)) return;
      currentTypes.push(obj.session_type);

      return {
        'description': DisplaySession[obj.session_type].session_name,
        'filterBy': 'session_type',
        'filter': obj.session_type,
        'action': action,
      };
    });

    filters.unshift({
      'description': 'All',
      'filterBy': 'session_type',
      'filter': 'all',
      'action': action,
    });

    return filters.filter(x => x);
  },

  'buildLocationFilters': function(data, action) {
    const currentLocations = [];

    const filters = data.map(obj => {
      if (currentLocations.includes(obj.shop_uuid)) return;
      currentLocations.push(obj.shop_uuid);

      return {
        'description': obj.shop_name,
        'filterBy': 'shop_uuid',
        'filter': obj.shop_uuid,
        'action': action,
      };
    });

    filters.unshift({
      'description': 'All',
      'filterBy': 'shop_uuid',
      'filter': 'all',
      'action': action,
    });

    return filters.filter(x => x);
  },
};

export default SessionFilterHelper;



// WEBPACK FOOTER //
// ./src/client/helpers/utilities/session-filters.js